import React from "react";
import PropTypes from "prop-types";
import SEO from "../components/seo";
import Layout from "../components/layout";
import { graphql } from "gatsby";
import GutenbergBlock from "../components/gutenberg-block.js";

export default function BlogPostTemplate({ data }) {
  return (
    <Layout>
      <div>
        <main>
          <SEO
            image={data?.wpContentNode?.featuredImage?.node?.sourceUrl}
            title={
              data.wpContentNode.seo?.title
                ? data.wpContentNode.seo.title
                    .replace("%%page%%", "")
                    .replace("%%sep%%", "")
                    .replace("%%sitename%%", "")
                : data.wpContentNode.title
            }
            description={data.wpContentNode.seo?.metaDesc}
            canonical={data.wpContentNode.seo?.canonical
              ?.replace("localhost:8000", "")
              .replace("enkle.re/MEV-DEV", "")
              .replace("https://", "")}
            url={data.wpContentNode.path}
          />

          {data?.wpContentNode?.blocks?.map((block, i) => (
            <div key={i} data-block={block.name}>
              <GutenbergBlock
                block={block}
                posts={data?.allWpPost}
                post={data?.wpContentNode}
              />
            </div>
          ))}
        </main>
      </div>
    </Layout>
  );
}

BlogPostTemplate.propTypes = {
  data: PropTypes.object,
};

export const query = graphql`
  query ($id: String!) {
    wpContentNode(id: { eq: $id }) {
      uri
      link
      slug
      contentTypeName
      nodeType
      date(formatString: "MMMM DD, YYYY")
      modified(formatString: "MMMM DD, YYYY")
      ... on WpPost {
        content
        excerpt
        title
        author {
          node {
            name
          }
        }
        categories {
          nodes {
            name
            databaseId
            uri
          }
        }
        seo {
          canonical
          title
          metaDesc
        }
        blocks {
          ...GutenbergBlocks
        }
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
      }
      ... on WpPage {
        content
        title
        author {
          node {
            name
          }
        }
        categories {
          nodes {
            name
            databaseId
            uri
          }
        }
        seo {
          canonical
          title
          metaDesc
        }
        blocks {
          ...GutenbergBlocks
        }
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
      }
      ... on WpCase {
        content
        title
        author {
          node {
            name
          }
        }
        categories {
          nodes {
            name
            databaseId
            uri
          }
        }
        seo {
          canonical
          title
          metaDesc
        }
        blocks {
          ...GutenbergBlocks
        }
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
      }
      ... on WpService {
        content
        title
        author {
          node {
            name
          }
        }
        categories {
          nodes {
            name
            databaseId
            uri
          }
        }
        seo {
          canonical
          title
          metaDesc
        }
        blocks {
          ...GutenbergBlocks
        }
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
      }
    }
    allWpPost(
      filter: {
        id: { nin: [$id] }
        featuredImage: { node: { sourceUrl: { ne: null } } }
      }
    ) {
      edges {
        node {
          id
          title
          slug
          databaseId
          uri
          categories {
            nodes {
              databaseId
              name
            }
          }
          blocks {
            ...GutenbergBlocks
          }
          excerpt
          date(formatString: "MMMM DD, YYYY")
          author {
            node {
              name
            }
          }
          featuredImage {
            node {
              altText
              sourceUrl
              mediaDetails {
                sizes {
                  name
                  sourceUrl
                }
              }
            }
          }
        }
      }
    }
  }
`;
